module.exports = __webpack_public_path__ + "static/img/10.ebf118f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/10.png
// module id = 2FA+
// module chunks = 0